<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <ManagerSidebar :toggler.sync="isToggled" />

      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getManagerUserProfile" />

      <ManagerPipelineWrapper />
      <!-- End page-content-wrapper -->
    </div>
  </div>
</template>

<script>
import ManagerSidebar from '@/components/Navigations/ManagerSidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import ManagerPipelineWrapper from '@/components/Manager/Pipeline/ManagerPipelineWrapper';

import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ManagerSidebar,
    TopNavbar,
    ManagerPipelineWrapper,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    isToggled: false,
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerProfile', 'retrieveManagerUserProfile']),
  },
  computed: { ...mapGetters('managerStoreModule', ['getManagerProfile', 'getManagerUserProfile']) },
  mounted() {
    this.retrieveManagerProfile();
  },
};
</script>
